module.exports = __webpack_public_path__ + "img/500f.990ed29d.png";